export default __webpack_public_path__ + "static/media/key-escape.5706911e.svg";